// import DeviceList from './index';
export default {
  priority: 100,
  path: "device-list",
  permissions: ["TimeAttendanceMenu/DeviceMenu/DeviceListMenu"],
  // component: DeviceList,
  component: load(() => import(/* webpackChunkName: "DeviceList" */ './index')),
  name: app.translate("routes.home.attendance.device.Device List"),
  icon: "deskphone",
  drawer: true,
};


